import DataStore from '@/app-core/lib/data/dataStore/DataStore'
import DataEventService from '@/app-core/lib/services/event/DataEventService'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'
import {clone} from '@/app-core/lib/utils/helper'
import {getPropValueWithDotNotation} from '@/core/lib/helpers/index.js'

export default {
  data() {
    return {}
  },
  methods: {
    menuItemToGAItem(data) {
      if (!data) return {}

      const item = clone(data)
      const name = getPropValueWithDotNotation(item, `Lang.${this.$i18n.locale}.Name`, item?.Name || '')
      const category = item?.CategoryName || ''
      const price = parseFloat(item.Price) || 0.0
      const discount = item?.SpecialStatus && item?.IsSpecial ? parseFloat(item?.Price || 0) - parseFloat(item?.SpecialPrice || 0) : 0.0
      const quantity = item?.UnitId > 1 ? parseInt(item?.UnitQuantity || 0) || 0 : parseInt(item?.Quantity || 0) || 0
      const variant = Array.isArray(item.Options) ? this.selectedOptionValues(item)?.map(option => getPropValueWithDotNotation(option, `Lang.${this.$i18n.locale}.Name`, []))?.join(', ') : getPropValueWithDotNotation(item, `Lang.${this.$i18n.locale}.Name`, [])
      const currency = this.AppConfig?.Marketplace?.Currency?.name || DataStore?.App?.Config?.Marketplace?.Currency?.name || 'EUR'
      const store = this.$dataStore?.App?.Stores?.find(store => store.Id === item.StoreId) || ''
      const brand = store ? `${store?.Slug}-${item.StoreId}` : `${item.StoreId}`

      return {
        id     : item.Id,
        item_id: item.Id,

        name     : name,
        item_name: name,

        brand     : brand,
        item_brand: brand,

        category     : category,
        item_category: category,

        price: price,

        discount: discount,

        quantity: quantity,

        variant     : variant,
        item_variant: variant,

        currency: currency
      }
    },

    setGACheckout() {
      if (!this.AppCart) return
      const cart = clone(this.AppCart)
      const currency = this.AppConfig?.Marketplace?.Currency?.name || DataStore?.App?.Config?.Marketplace?.Currency?.name || 'EUR'
      const orderTotal = parseFloat(cart.OrderTotal) || 0.0
      const totalItems = parseInt(cart.TotalItems) || 0
      const coupon = cart?.Totals?.find(total => total.name === 'coupon')?.code || ''
      const items = []

      for (let i = 0; i < cart.Items.length; i++) {
        items.push(this.menuItemToGAItem(cart.Items[i]))
      }

      DataEventService.Emit(DataEventEnum.EVENT, {
        Event  : DataEventEnum.BEGIN_CHECKOUT,
        Payload: {
          items            : items,
          value            : orderTotal,
          currency         : currency,
          coupon           : coupon,
          cartTotalQuantity: totalItems
        }
      })
    },

    setPurchaseGA(orderId, customer) {
      if (!this.AppCart) return
      const cart = clone(this.AppCart)
      const currency = this.AppConfig?.Marketplace?.Currency?.name || DataStore?.App?.Config?.Marketplace?.Currency?.name || 'EUR'
      const orderTotal = parseFloat(cart.OrderTotal) || 0.0
      const totalItems = parseInt(cart.TotalItems) || 0
      const coupon = cart?.Totals?.find(total => total.name === 'coupon')?.code || ''
      const items = []

      for (let i = 0; i < cart.Items.length; i++) {
        items.push(this.menuItemToGAItem(cart.Items[i]))
      }

      DataEventService.Emit(DataEventEnum.EVENT, {
        Event  : DataEventEnum.PURCHASE,
        Payload: {
          items            : items,
          value            : orderTotal,
          currency         : currency,
          coupon           : coupon,
          cartTotalQuantity: totalItems,
          transaction_id   : orderId || '',
          user             : {
            firstname: customer?.Firstname || '',
            lastname : customer?.Lastname || '',
            email    : customer?.Email || ''
          }
        }
      })
    },

    setGAPaymentInfo(paymentType) {
      if (!this.AppCart) return
      const cart = clone(this.AppCart)
      const currency = this.AppConfig?.Marketplace?.Currency?.name || DataStore?.App?.Config?.Marketplace?.Currency?.name || 'EUR'
      const orderTotal = parseFloat(cart.OrderTotal) || 0.0

      DataEventService.Emit(DataEventEnum.EVENT, {
        Event  : DataEventEnum.ADD_PAYMENT_INFO,
        Payload: {
          value       : orderTotal,
          currency    : currency,
          payment_type: paymentType
        }
      })
    },

    selectedOptionValues(product) {
      if (!product) return []

      const options = product?.Options || []
      const selectedOptions = []

      for (let i = 0; i < options.length; i++) {
        const option = options[i]
        const optionValuesLength = option?.OptionValues?.length || 0
        for (let ii = 0; ii < optionValuesLength; ii++) {
          const optionValue = option.OptionValues[ii]

          if (option.DisplayType === 'checkbox') {
            if (optionValue.Selected) selectedOptions.push(optionValue)
          }
          if (option.DisplayType === 'radio') {
            const defaultValueId = option?.DefaultValueId?.toString()
            const valueId = optionValue?.Id?.toString()
            if (defaultValueId === valueId) selectedOptions.push(optionValue)
          }
        }
      }

      return selectedOptions
    }
  }
}
